import { Call } from '@twilio/voice-sdk';
import { CronoCallEvent, CronoCallState } from './cronoCallReducer';
import useStartTwilioRecord from 'hooks/services/call/useStartTwilioRecord';
import { hasActiveCall } from './guards';

export const useRecordingControls = ({
  callRef,
  send,
  state,
  wasRecorded,
}: {
  callRef: React.MutableRefObject<Call | undefined>;
  send: React.Dispatch<CronoCallEvent>;
  state: CronoCallState;
  wasRecorded: React.MutableRefObject<boolean>;
}) => {
  const { mutate: startRecord } = useStartTwilioRecord({
    onSuccess: () => {
      send({ type: 'callRecordingStarted' });
      wasRecorded.current = true;
    },
  });

  const startRecording = () => {
    if (!hasActiveCall(callRef.current)) return;
    if (!callRef.current.parameters.CallSid) {
      console.error('[useCronoCall] No CallSid found.');
      return;
    }
    send({ type: 'callRecordingRequested' });
  };

  const confirmRecording = () => {
    if (!hasActiveCall(callRef.current)) return;
    if (!callRef.current.parameters.CallSid) {
      console.error('[useCronoCall] No CallSid found.');
      return;
    }
    if (state.status !== 'recordingDisclaimer') {
      console.error(
        `[useCronoCall] Status should be recordingDisclaimer but found ${state.status}.`,
      );
      return;
    }
    startRecord({
      callSid: callRef.current.parameters.CallSid,
    });
  };

  const cancelRecording = () => {
    send({ type: 'callRecordingCanceled' });
  };

  return {
    startRecording,
    confirmRecording,
    cancelRecording,
  };
};
